import config from '../data/config.json';
import Mustache from 'mustache';


/////////////// SOLR

function TextEngine(suggestPath, selectPath) {
	// inicialización de opciones
	const options = {
			method: 'GET',
			headers: {	'Content-Type': 'application/json'	}
		};
			
	// test 
	this.test = async function() {
		// pruebo las sugerencias
		//console.debug(suggestPath);
		const sug = await fetch(suggestPath, options);
		if (sug.ok) { // if HTTP-status is 200-299
			// fue bien, pruebo la selección
			//console.debug(selectPath);
			const sel = await fetch(selectPath, options);
			if (sel.ok)
				return Promise.resolve(true);
			else {
				// logging del error
				const mens = 'SOLR error - url: ' + selectPath
					+ ' - code: ' + sel.status + ' - mens: ' + sel.statusText;
				// rechazo la promesa
				return Promise.reject(mens);				
			}		
		} 
		else {
			// logging del error
			const mens = 'SOLR error - url: ' + suggestPath
				+ ' - code: ' + sug.status + ' - mens: ' + sug.statusText;
			// rechazo la promesa
			return Promise.reject(mens);
		}
	}
	
	// petición sugerencias
	this.getSuggestions = async function(input) {
		// preparo la url de la petición
		const url = suggestPath + Mustache.render(config.solrConfig.suggestTemplate, {'input': input} );
		// hago petición
		const datos = await this.getData(url);
		return datos;
	}
	
	// petición documento
	this.getDocument = async function(id) {
		// preparo la url de la petición
		const url = selectPath + Mustache.render(config.solrConfig.selectTemplate, {'id': id} );
		// hago petición
		const datos = await this.getData(url);			
		return datos;
	}
	
	this.getData = async function(url) {
		// hago log de la url
		//console.debug(url);
		// hago la petición
		const response = await fetch(url, options);
		if (response.ok) { // if HTTP-status is 200-299
			// petición exitosa
			const datos = await response.json();
			// devuelvo los datos
			return Promise.resolve(datos);		
		} else  { // logging del error
			const eobj = {
				status: response.status,
				url: url,
				mens: 'SOLR error - url: ' + url
				+ ' - code: ' + response.status + ' - mens: ' + response.statusText
			};
			// rechazo la promesa
			return Promise.reject(eobj);
		}	
	}	
}



/////////////// CRAFTS

function CraftsAPI(craftsConfig) {
	
	//const CACHE_VERSION = 1;
	const CACHE_NAME = 'forexp-cache-' + config.versionCode;
	// ya no purgo la caché
	//const CACHE_LIFE = 604800000; // 7*24*3600*1000 ms, una semana como máximo
	let datacache;
	let cacheurls; // urls a considerar organizada con claves por id
	let cacheindex; // índice organizada con claves por id de cada iri a las urls para que ocupe menos

	// inicialización de opciones
	const options = {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': craftsConfig.auth
			}
		};
			
	// test 
	this.test = async function() {
		// ajusto método
		options.method = 'GET';
		// hago log de la url de prueba
		console.debug(craftsConfig.api);
		const response = await fetch(craftsConfig.api, options);
		if (response.ok) {// if HTTP-status is 200-299
			//await this.initCache(); // aprovecho para inicializar la caché y las urls guardadas
			// abro la caché
			datacache = await caches.open(CACHE_NAME);
			return Promise.resolve(true);
		}
		else  {
			// logging del error
			// leo la respuesta del error
			const resperr = await response.json();
			const eobj = {
				message: 'CRAFTS error: ' + resperr.message,
				error: {
					url: craftsConfig.api,
					status: response.status,
					statusText: response.statusText			
				}
			};
			// rechazo la promesa
			return Promise.reject(eobj);
		}
	}
	
	// inicializo caché
	this.initCache = async function() {
		if (!datacache)
			datacache = await caches.open(CACHE_NAME);
							
		console.time("Indexado caché");
		// extraigo las urls
		const urls = (await datacache.keys()).map(key => key.url);
		// inicializo cacheurls
		cacheurls = {};
		// filtro urls y organizo cacheurls
		for (const elind of config.craftsCacheIndex) {
			// me quedo sólo con las urls que pasan el filtro
			const cfurls = urls.filter(url => url.startsWith(config.craftsConfig.api + elind.pref));
			// organizo en cacheurls
			for (const curl of cfurls) {
				// extraigo el id
				const urlobj = new URL(curl);
				const id = urlobj.searchParams.get('id');
				// guardo
				if (!cacheurls[id])
					cacheurls[id] = [];
				cacheurls[id].push(curl);
			}
		}
		// inicializo el índice
		cacheindex = {};
		let nicurls = 0;
		// preparo el índice
		for (const id in cacheurls) {
			// inicializo id en el índice
			cacheindex[id] = {};
			// indexo cada url
			for (let i=0; i<cacheurls[id].length; i++) {
				const curl = cacheurls[id][i];
				nicurls++;				
				// obtengo el nombre del query parameter para las iris
				let irisqp = config.craftsCacheIndex[0].iris; // valor por defecto
				for (let i=0; i<config.craftsCacheIndex.length; i++) {
					if (curl.startsWith(config.craftsConfig.api + config.craftsCacheIndex[i].pref)) {
						irisqp = config.craftsCacheIndex[i].iris;
						break;
					}
				}				
				// hago el parsing de la url
				const urlobj = new URL(curl);		
				const ns = urlobj.searchParams.get('ns');
				for (const iri of urlobj.searchParams.getAll(irisqp)) {
					if (!ns)
						cacheindex[id][iri] = i; // guardo el índice para que ocupe menos
					else {
						const realiri = ns + iri.split(":")[1];
						cacheindex[id][realiri] = i; // guardo el índice para que ocupe menos
					}
				}		
			}		
		}
		console.info("Caché - #entradas: " + urls.length + " #indexadas: " + nicurls);
		console.timeEnd("Indexado caché");
		
		// borrado cachés antiguas
		caches.keys().then((cacheNames) =>
			Promise.all(
				cacheNames.map((cacheName) => {
					if (cacheName !== CACHE_NAME) {
						console.log("Deleting out of date cache:", cacheName);
						return caches.delete(cacheName);
					}
				}),
			),
		);
	}
	
	this.cacheandoAdhoc = async function(url, obj) {	
		if (!datacache)
			await this.initCache();
		console.debug("cacheando ad hoc: " + url);
		await datacache.put(url, new Response(JSON.stringify(obj)));		
	}
	
	this.getCacheUrl = function(id, iri) {
		if (!cacheindex)
			return undefined;
		if (!cacheindex[id])
			return undefined;
		return cacheurls[id][ cacheindex[id][iri] ];
	}
	
	this.getCacheData = async function(url, cachinfo) {
		const cacheresp = await datacache.match(url);
		if (cacheresp) {
			console.debug("cacheado: " + url);
			if (cachinfo)
				cachinfo.urlsCache.push(1);
			const datos = await cacheresp.json();
			return Promise.resolve(datos);
			//return Promise.resolve(datos.data);
		}
		else
			return Promise.reject("No está en la caché");
	}
	
	// petición tipo GET de CRAFTS
	this.getData = async function(template, objpars, nocachear, cachinfo) {
		// ajusto método y body
		options.method = 'GET';
		delete options.body;
		// preparo la url de la petición
		const url = craftsConfig.api + Mustache.render(template, objpars);
		
		// si hay caché, intento recuperarlo
		if (!nocachear) {
			// inicializo la caché si hiciera falta
			if (!datacache)
				await this.initCache();		
			// pido emparejamiento
			const cacheresp = await datacache.match(url);
			if (cacheresp) {
				console.debug("cacheado: " + url);
				if (cachinfo)
					cachinfo.urlsCache.push(1);
				const datos = await cacheresp.json();
				return Promise.resolve(datos);
				//return Promise.resolve(datos.data);			
			}
		}
		
		// voy a la red
		console.debug("red: " + url);		
		if (cachinfo)
			cachinfo.urlsRed.push(1);
		// hago la petición
		const response = await fetch(url, options);
		if (response.ok) { // if HTTP-status is 200-299
			// petición exitosa
			// si hay caché, guardo la respuesta
			if (!nocachear) 
				datacache.put(url, response.clone());			
			// recupero los datos
			const datos = await response.json();
			// guardo en la caché con el timestamp para limpiar la caché
			//const cachedresp = { data: datos, timestamp: Date.now() };			
			//datacache.put(url, new Response(JSON.stringify(cachedresp)));			
			// devuelvo los datos
			return Promise.resolve(datos);
		} else  { // logging del error
			// leo la respuesta del error
			const resperr = await response.json();
			const eobj = {
				message: 'CRAFTS error: ' + resperr.message,
				error: {
					url: url,
					status: response.status,
					statusText: response.statusText			
				}
			};
			// rechazo la promesa
			return Promise.reject(eobj);
		}
	}
}

export { CraftsAPI, TextEngine };